import { globs } from "../../../../../../../services/globs";
import { FORM_TIMEZONE_TYPES } from "../../../../../../../constants";
import template from "./edit-effective-range.html";
import "./edit-effective-range.less";

import moment from "moment";
import swal from "sweetalert2";

export function controller($logger, toastr, securityService, timezoneService) {
	const ctrl = this;
	this.modelValues = {};

	ctrl.handleClose = handleClose;
	ctrl.handleSave = handleSave;

	ctrl.$onInit = function() {
		const timeZoneConfig = timezoneService.getConfiguredTimezoneCode(ctrl.resolve.entity);
		
		if(ctrl.resolve.timeMode === FORM_TIMEZONE_TYPES.ByEntity && !timeZoneConfig.exact) {
			swal({
				title: "Configuration Error",
				text: "The selected entity does not have a timezone configured, but the form is set to use entity timezone.",
				type: "error",
				confirmButtonText: "OK"
			}).then(() => {
				ctrl.modalInstance.dismiss();
			});
			return;
		}

		ctrl.timeZoneMode = timeZoneConfig.timeZoneCode;
		ctrl.timeZoneName = timeZoneConfig.timeZoneAbbr || "Local";
		
		if(ctrl.resolve.range) {
			ctrl.modelValues = {
				...ctrl.resolve.range
			};
		}
	};

	function handleSave() {
		const values = {
			...this.modelValues,
			Start: this.modelValues.Start,
			End: this.modelValues.End,
			AsEarlyAs: this.modelValues.AsEarlyAs,
			NoLaterThan: this.modelValues.NoLaterThan,
			Scope: this.modelValues.Scope?.toUpperCase()
		};

		const errs = validate(values);
		if(!!errs?.length) {
			toastr.error(`${errs.map(e => `\u2022 ${e}`).join("<br/>")}`);
			return;
		}
		ctrl.modalInstance.close(values);
	}

	function handleClose() {
		ctrl.modalInstance.dismiss();
	}

	function validate(values) {
		const errors = [];
		if(values.Start === undefined) {
			errors.push("Start value cannot be empty");
		}

		const moments = {
			start: moment(values.Start),
			end: values.End && moment(values.End),
			asEarlyAs: values.AsEarlyAs && moment(values.AsEarlyAs),
			noLaterThan: values.NoLaterThan && moment(values.NoLaterThan)
		};

		if(moments.asEarlyAs && moments.start.isBefore(moments.asEarlyAs)) {
			errors.push("As Early As value must be before Start value");
		}
		if(moments.noLaterThan && moments.start.isSameOrAfter(moments.noLaterThan)) {
			errors.push("No Later Than value must be after Start value");
		}
		if(moments.end) {
			if(moments.start.isAfter(moments.end)) {
				errors.push("Start value must be before End value");
			}
			if(moments.noLaterThan && moments.noLaterThan.isBefore(moments.end)) {
				errors.push("No Later Than value must be after End value");
			}
		}

		if(values.Scope) {
			const scopeAction = ctrl.resolve.range === undefined ? 
				globs.entityTypes.byType(ctrl.resolve.typeConfig.Code).effective.byCode(values.Scope).create
				: globs.entityTypes.byType(ctrl.resolve.typeConfig.Code).effective.byCode(values.Scope).update;

			const isScopeAllowed = securityService.isActionAllowed(scopeAction);

			if(!isScopeAllowed) {
				errors.push("Scope is invalid.");
			}
		}

		return errors;
	}
}

export default angular.module("vesl.components.edit-effective-range-modal", [])
	.component("editEffectiveRangeModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	})
	.name;
